<template>
  <div class="product-reviews">
    <ProductReviewsTitle>
      <span> {{ messages.reviewsFor + ' ' + product.name }} </span>
    </ProductReviewsTitle>

    <DefButtonPrimary
        @click.native="openReviewModal"
    >
      {{ messages.leaveReview }}
    </DefButtonPrimary>

    <ProductReview
        v-if="comments.length > 0"
        v-for="item in comments"
        :key="item.ID" :result="item"
        :messages="messages"
        :user="user"
        @openReviewModal="openReviewModal"
    />

    <DefModal
        :model-value="productReviewModalParams.opened"
        @close="productReviewModalParams.opened=false"
    >
      <ProductReviewModal
          v-bind="productReviewModalParams"
          @close="productReviewModalParams.opened=false"
          @openSuccessModal="handleOpenSuccessModal"
      />
    </DefModal>

    <DefModal
        :model-value="productReviewGuestModalParams.opened"
        @close="productReviewGuestModalParams.opened=false">
      <ProductReviewGuestModal
          v-bind="productReviewGuestModalParams"
      />
    </DefModal>

    <DefModal :model-value="productReviewSuccessModal.opened">
      <ProductReviewSuccessModal v-bind="productReviewSuccessModal" class="product-review-success-modal" />
    </DefModal>


  </div>
</template>

<script>
import {mapState} from 'vuex';
import ProductReviewsTitle from "./ProductReviewsTitle.vue";
import DefButtonPrimary from "../../Def/DefButtonPrimary/DefButtonPrimary.vue";
import ProductReview from "./ProductReview.vue";
import ProductReviewModal from "./Modal/ProductReviewModal.vue";
import ProductReviewGuestModal from "./Modal/ProductReviewGuestModal.vue";
import DefModal from "../../Def/DefModal/DefModal.vue";
import ProductReviewSuccessModal from "./Modal/ProductReviewSuccessModal.vue";

export default {
  name: "ProductReviews",
  components: {
    ProductReviewSuccessModal,
    DefModal,
    ProductReviewModal, ProductReviewGuestModal, ProductReview, DefButtonPrimary, ProductReviewsTitle
  },
  selector: '.product-reviews',
  data: () => ({
    productReviewModalParams: {
      opened: false,
    },
    productReviewGuestModalParams: {
      opened: false,
    },
    productReviewSuccessModal: {
      opened: false
    }
  }),
  computed: {
    ...mapState({
      product: ({product}) => product.data.product,
    }),
    comments() {
      return this?.product?.comments?.items;
    },
    messages() {
      return this?.product?.comments?.messages;
    },
    description() {
      return this?.product?.comments?.description;
    },
    user() {
      return this?.product?.comments?.user;
    },
    recaptchaKey() {
      return this?.product?.recaptchaKey;
    }
  },
  methods: {
    handleOpenSuccessModal(params) {
      this.productReviewSuccessModal = {
        opened: true,
        messages: params,
      }
    },
    openReviewModal(params) {
      console.log('openReviewModal', params);
      if (this.user) {
        this.productReviewModalParams = {
          opened: true,
          messages: this.messages,
          description: this.description,
          user: this.user,
          product: this.product,
          recaptchaKey: this.recaptchaKey,
          depth_level: params.UF_ELEMENT_ID ? +params.UF_DEPTH_LEVEL + 1 : 0,
          parent_comment: params.UF_ELEMENT_ID ? params?.ID : '',
        };

        var recaptchaKey = this.recaptchaKey;
        setTimeout(function () {
          grecaptcha.render("recaptcha-1", {
            sitekey: recaptchaKey
          });
        }, 1000);
      } else {
        localStorage.setItem('isShowReviewModalAfterRedirect', true)
        this.productReviewGuestModalParams = {
          opened: true,
          messages: this.messages,
          description: this.description,
          review: params.UF_ELEMENT_ID ? params : [],
        };

        // location.href = this.messages.pathToCabinet.link;
      }
    },

    /**
     * костыль по требованию клиента - когда юзер неавторизован кликает на кнопку оставить отзыв его отправляет на форму авторизации и после авторизации
     * тригерится клик по той кнопке (только при условии что редирект был именно со страницы авторизации)
     */
    showReviewModalAfterRedirect() {
      if (localStorage.getItem('isShowReviewModalAfterRedirect') && this.user) {
        let backURL = this.messages.httpReferer.link;
        if (backURL) {
          backURL = decodeURIComponent(backURL)

          let url = backURL.split('?');
          let urlSplit = url?.[2];

          if (urlSplit) {
            const searchParams = new URLSearchParams('?' + urlSplit);
            const reviewID = searchParams.get('reviewID');
            if (reviewID === 'N') {
              let btnLeaveReview = document.querySelector('.product-reviews .def-button-primary[type=button]');
              btnLeaveReview.scrollIntoView();
              btnLeaveReview.click();
            } else if (reviewID) {
              const elements = document.querySelectorAll('[data-review-id]');
              elements.forEach(el => {
                if (el.getAttribute('data-review-id') == reviewID) {
                  el.scrollIntoView();
                  el.click();
                }
              });
            }
            localStorage.removeItem('isShowReviewModalAfterRedirect');
          }
        }
      }
    }
  },
  mounted() {
    this.showReviewModalAfterRedirect();
  }
}
</script>
<style>
.product-reviews {
  clear: both;
  float: left;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss" scoped>
.product-reviews {
  max-width: 760px;
  margin: 0 auto 50px;

  :deep(.def-button-primary) {
    transform: translate(-50%, -50%);
    left: 50%;
    position: relative;
    top: 30px;
    margin-bottom: 20px;
    border: 0;
    cursor: pointer;
    width: 200px;
  }
}
</style>

<style>
.product-review-success-modal .def-modal__body{
  max-width: 470px;
  top: 85vh;
  left: unset;
  right: 20px;
  transform: unset;
}
</style>